import {Component, OnDestroy, OnInit} from "@angular/core";
import {EingabeStepComponent} from "./eingabe.step.component";
import {FormModel} from "../../form/form.model.abstract";
import {PhotovoltaikcheckConstants} from "../photovoltaikcheck.constants";
import Map from 'ol/Map';
import View from 'ol/View';
import {defaults as defaultControls} from 'ol/control/defaults';
import TileLayer from 'ol/layer/Tile';
import {fromLonLat, toLonLat} from "ol/proj";
import {OSM, XYZ} from "ol/source";
import {StepService} from "../../services/step.service";
import {ActivatedRoute, Router} from "@angular/router";
import {PhotovoltaikcheckRequestService} from "../services/request.service";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {HttpClient} from "@angular/common/http";
import {UntypedFormControl, Validators} from "@angular/forms";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {Draw} from "ol/interaction";
import {Feature} from "ol";
import {getArea} from "ol/sphere";
import {Polygon} from "ol/geom";
import {DrawEvent} from "ol/interaction/Draw";
import {TranslateService} from "@ngx-translate/core";
import {CancelControl, ResetControl} from "../map/map.resetcontrol";
import {DrawStyle} from "../map/map.drawstyle";
import {Coordinate} from "ol/coordinate";
import {GeolocationControl} from "../map/map.gelocation.control";
import {GeoJSON} from "ol/format";
import {DecimalPipe} from "@angular/common";
import {FormfieldDirectionComponent} from "../../formfield/formfield.direction.component";

/**
 * Overwrite the Generic step component for the first section fo the photovoltaikcheck.
 *
 * @inheritDoc
 */
@Component({
    selector: 'app-step-eingabe-roofarea-pvc',
    templateUrl: './eingabe.roof-area.component.html',
    providers: [DecimalPipe],
    standalone: false
})
export class EingabeRoofAreaComponent extends EingabeStepComponent implements OnInit, OnDestroy {
  /**
   * Default helptext of this step.
   */
  readonly helpTextkeyDefault = 'photovoltaikcheck.help.aufstellort.3';

  /**
   * Some error indicators when using the map
   */
  readonly MAP_ERROR_SHORT = 'short';
  readonly MAP_ERROR_NOTFOUND = 'notfound';
  readonly MAP_ERROR_INTERNAL = 'internal';

  /**
   * some hint text indicators that are shown on the map
   */
  readonly MAP_HINT_ADDRESS = 'address';
  readonly MAP_HINT_DRAW = 'draw';

  /**
   * toggle to show the switch with the calculation helper.
   */
  showSwitch: boolean = false;

  /**
   *
   */
  field: string = PhotovoltaikcheckConstants.MODE_FLAECHE;

  /**
   * list of fomfields that we use for the calculation
   */
  formFields: {[key: string]: FormModel} = {};

  /**
   * The map.
   */
  map: Map;

  /**
   * The (current) center of the map. Preset by middle of Germany
   */
  mapCenter: Coordinate = [10.4515, 51.1657];

  /**
   * Remember if we already centered the map.
   */
  mapCentered: boolean = false;

  /**
   * the (current) map zoom.
   */
  mapZoom: number = 6;

  /**
   * textkey for the hint that is shown on the map.
   */
  mapHintText: string = null;

  /**
   * toggle for a loading indicator of the map.
   */
  mapLoading: boolean = false;

  /**
   * extra vector layer for the map
   */
  vectorLayer: VectorLayer<any>;

  /**
   * extra vector source for the map, part of the vector layer.
   */
  vectorSource: VectorSource;

  /**
   * the draw interaction of the map.
   */
  drawInteraction: Draw;

  /**
   * Polygon feature for calculating areas.
   */
  polygonFeature: Feature;

  /**
   * sum of all polygons that are drawn on the map.
   */
  drawArea: number = 0;

  /**
   * toggle for showing an error message if the given address was not found.
   */
  searchError: string = null;

  /**
   * extra postfix for the helptext
   */
  helptextPostfix: string = '';

  /**
   * calculated available area depending on living area
   */
  availableArea: number;

  /**
   * Overwrite parent constructor and add some more services.
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param portalService
   * @param route
   * @param http
   * @param translate
   * @param decimapPipe
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: PhotovoltaikcheckRequestService,
              protected elementService: ElementService, protected portalService: PortalService, protected route: ActivatedRoute,
              protected http: HttpClient, protected translate: TranslateService, protected decimapPipe: DecimalPipe) {
    super(stepService, router, requestService, elementService, portalService, route, decimapPipe);
  }

  /**
   * @inheritdoc
   */
  ngOnInit() {
    super.ngOnInit();

    // get the input fiueld from the form
    this.formFields[PhotovoltaikcheckConstants.MODE_FLAECHE] = this.formConfig.getField(PhotovoltaikcheckConstants.MODE_FLAECHE);
    this.formFields[PhotovoltaikcheckConstants.MODE_WOHNFLAECHE] = this.formConfig.getField(PhotovoltaikcheckConstants.MODE_WOHNFLAECHE);
    this.formFields[PhotovoltaikcheckConstants.MODE_STOCKWERKE] = this.formConfig.getField(PhotovoltaikcheckConstants.MODE_STOCKWERKE);

    // check if we should show the switch with alternative inputs or not
    this.showSwitch = this.anfrage.userInput.aufstellort !== PhotovoltaikcheckConstants.AUFSTELLORT_FASSADE;
    // if not, show extra helptext
    if(this.anfrage.userInput.aufstellort === PhotovoltaikcheckConstants.AUFSTELLORT_FASSADE) {
      this.helptextPostfix = '.fassade';
    }

    if(this.anfrage.userInput.aufstellort === PhotovoltaikcheckConstants.AUFSTELLORT_SPITZDACH &&
      FormfieldDirectionComponent.isEastWest(this.anfrage.userInput.himmelsausrichtung)
    ) {
      this.helptextPostfix += '.ostwest';
    }

    // init helptextkey
    this.helpTextkey = this.helpTextkeyDefault + this.helptextPostfix;

    // subscribe for changes on living ara and floor
    this.subscriptions.push(this.form.get(PhotovoltaikcheckConstants.MODE_STOCKWERKE).valueChanges.subscribe(
      () => this.calculateAreaFromCalculator())
    );
    this.subscriptions.push(this.form.get(PhotovoltaikcheckConstants.MODE_WOHNFLAECHE).valueChanges.subscribe(
      () => this.calculateAreaFromCalculator())
    );

    // add extra formcontrol for the address search and the area sum
    this.form.addControl(PhotovoltaikcheckConstants.FIELD_ADDRESS, new UntypedFormControl(''));
    this.form.addControl(PhotovoltaikcheckConstants.FIELD_DRAWAREA,
      new UntypedFormControl('',
        [Validators.required,
            Validators.min(PhotovoltaikcheckConstants.VALIDATE_FLAECHE_VERFUEGBAR_MIN),
          Validators.max(PhotovoltaikcheckConstants.VALIDATE_FLAECHE_VERFUEGBAR_MAX)
        ]));
    this.form.get(PhotovoltaikcheckConstants.FIELD_DRAWAREA).disable();

    // preset the last calculator that was used. If there is one.
    if(this.anfrage.userInput.areaCalculator) {
      // preset inputs of the calculator, if there are some
      if(this.anfrage.mapAddress) {
        this.form.get(PhotovoltaikcheckConstants.FIELD_ADDRESS).setValue(this.anfrage.mapAddress);
      }

      this.setField(this.anfrage.userInput.areaCalculator);
    }
  }

  /**
   * @inheritdoc
   */
  ngOnDestroy() {
    super.ngOnDestroy();

    // remove extra controls from form.
    this.form.removeControl(PhotovoltaikcheckConstants.FIELD_ADDRESS);
    this.form.removeControl(PhotovoltaikcheckConstants.FIELD_DRAWAREA);
  }

  /**
   * initialize the map and all interactions that we have on the map.
   */
  initMap(): void {

    // use some timeout for the init to make sure the html wrapper is loaded.
    setTimeout(() => {
      // buld tzhe vector layer for the interactions
      this.vectorSource = new VectorSource();

      this.vectorLayer = new VectorLayer({
        source: this.vectorSource,
        style: new DrawStyle()
      });

      // define the map
      this.map = new Map({
        target: 'map', // target element with id="map"

        // basic settings
        view: new View({
          center: fromLonLat(this.mapCenter),
          zoom: this.mapZoom,
          projection: PhotovoltaikcheckConstants.MAP_PROJECTION,
          maxZoom: PhotovoltaikcheckConstants.MAP_MAX_ZOOM
        }),

        // extra control for the reset button.
        controls: defaultControls().extend([
          new ResetControl({
            label: this.translate.instant('photovoltaikcheck.map.controls.reset'),
            handleClick: (event: Event) => {
              event.preventDefault();
              this.resetPolygons();
            }
          }),
          new CancelControl({
            label: this.translate.instant('photovoltaikcheck.map.controls.cancel'),
            handleClick: (event: Event) => {
              event.preventDefault();
              this.resetPolygons();
            }
          }),
          new GeolocationControl({})
        ]),

        // add all layers
        layers: [
          // default, sattelite
          new TileLayer({
            source: new XYZ({
              url: `https://atlas.microsoft.com/map/tile?api-version=2.0&tilesetId=microsoft.imagery&zoom={z}&x={x}&y={y}&subscription-key=${PhotovoltaikcheckConstants.AZURE_MAPS_KEY}`,
              projection: 'EPSG:3857',
              tileSize: 256
            }),
            visible: true,
          }),
          // secondary, map
          new TileLayer({
            source: new OSM(),
            visible: false,
          }),
          // interaction/drawing layer
          this.vectorLayer
        ],
      });

      // remeber zoomlevel and last position.
      this.map.getView().on('change:center', () => this.saveMapState());
      this.map.getView().on('change:resolution', () => this.saveMapState());

      // initially center the map on the users position.
      if(this.mapCentered === false) {
        // only do this once
        this.centerMapOnUser();
        this.mapCentered = true;
      }

      // preset polygons if there are some
      if(this.anfrage.mapPolygons) {
        this.importPolygons();
      }

      // add interaction feature to the map.
      this.addInteractions();
    }, 500);
  }

  /**
   * When the map position is changed, remember the last position and zoom level.
   */
  saveMapState() {
    this.mapCenter = toLonLat(this.map.getView().getCenter());
    this.mapZoom = this.map.getView().getZoom();
  }

  /**
   * Center the map to the users position that s/he has given before in the advisor.
   * The browser position is used.
   */
  centerMapOnUser() {
    if(this.anfrage.mapAddress) {
      // set map on previously given address of the user
      this.setAddress(this.anfrage.mapAddress, PhotovoltaikcheckConstants.MAP_ADDRESSSEARCH_ZOOM);
    }
    else if(this.anfrage?.userInput?.postleitzahl) {
      // set map on postal code, given earlyer in the process
      this.setAddress(this.anfrage.userInput.postleitzahl + ' Deutschland', PhotovoltaikcheckConstants.MAP_GELOCATION_ZOOM);
    }
  }

  /**
   * Locate a given address on the map.
   * Is called with click on the search button and by pressing enter on the search input.
   * @param event
   */
  locateAddress(event: Event) {
    // ignore default event and reset error message.
    event.preventDefault();
    this.searchError = null;
    this.mapHintText = null;

    // get the address from the input and validate if we have one.
    const address = this.form.get(PhotovoltaikcheckConstants.FIELD_ADDRESS).value;
    if(!address || address.length < PhotovoltaikcheckConstants.MAP_ADDRESS_MINLENGTH) {
      this.searchError = this.MAP_ERROR_SHORT;
      return;
    }

    // save the address in the browser
    this.anfrage.mapAddress = address;
    this.requestService.setAnfrage(this.anfrage);

    this.setAddress(address);
  }

  /**
   * set a given address on the map
   * @param address
   * @param zoom
   */
  setAddress(address: string, zoom: number = PhotovoltaikcheckConstants.MAP_ADDRESSSEARCH_ZOOM) {
    // get apikey, prepare search string, build search url
    const apiKey = PhotovoltaikcheckConstants.AZURE_MAPS_KEY;
    const query = encodeURIComponent(address);
    const url = `https://atlas.microsoft.com/search/address/json?api-version=1.0&query=${query}&subscription-key=${apiKey}`;
    this.mapLoading = true;

    // do the search
    this.http.get(url).subscribe((response: any) => {
      if (response && response.results && response.results.length > 0) {
        // we have a location, build coordnates
        const location = response.results[0].position;

        // animate the map to the given address
        this.map.getView().animate({
          center: fromLonLat([location.lon, location.lat]),
          zoom
        });

        // change hint text, if the address was already given
        if(this.form.get('address')?.value.length > PhotovoltaikcheckConstants.MAP_ADDRESS_MINLENGTH) {
          this.mapHintText = this.MAP_HINT_DRAW;
        }
        // hide hint text, if there are already some polygons
        if(this.anfrage.mapPolygons) {
          this.mapHintText = null;
        }
      }
      else {
        // there was an error. Network error, address not found, anything else.
        this.searchError = this.MAP_ERROR_NOTFOUND;
      }
      this.mapLoading = false;
    }, error => {
      this.searchError = this.MAP_ERROR_INTERNAL;
      this.mapLoading = false;
    });
  }

  /**
   * bind the interaction (drawing polygons) to the map.
   */
  addInteractions() {
    // build draw and style
    this.drawInteraction = new Draw({
      source: this.vectorSource,
      type: 'Polygon',
    });

    // add interaction
    this.map.addInteraction(this.drawInteraction);

    // bind event if the drawing has an end.
    this.drawInteraction.on('drawend', (event) => this.calculateAreaOfPolygon(event));

    this.drawInteraction.on("drawstart", event => {
      // hide the hint text
      this.mapHintText = null;

      // show the cancel button
      this.showCancelButton();
    });
  }

  /**
   * Show the cancel button on the map.
   */
  showCancelButton(): void {
    this.map.getControls().forEach(control => {
      if(control instanceof CancelControl) {
        control.show();
      }
    });
  }

  /**
   * Show the rest button on the map
   */
  showResetButton(): void {
    this.map.getControls().forEach(control => {
      if(control instanceof ResetControl) {
        control.show();
      }
      if(control instanceof CancelControl) {
        control.hide();
      }
    });
  }

  /**
   * After drawing a polygon, the area of this polygon is calculated.
   * @param event
   */
  calculateAreaOfPolygon(event: DrawEvent): void {
    // show reset button, search on all controls of the map.
    this.map.getControls().forEach(control => {
      if(control instanceof ResetControl) {
        control.show();
      }
      if(control instanceof CancelControl) {
        control.hide();
      }
    });

    // get the polygon and the area
    this.polygonFeature = event.feature;

    // set the area as label to the polygon by setting a new style
    const area = this.setTextOnPolygon(this.polygonFeature);

    // add the calculated area to the area sum. And set it to the input of the available area.
    this.drawArea += area;
    this.form.get(PhotovoltaikcheckConstants.FIELD_DRAWAREA).setValue(Math.round(this.drawArea));
    this.form.get(PhotovoltaikcheckConstants.MODE_FLAECHE).setValue(Math.round(this.drawArea));

    // save current drawed polygons
    setTimeout(() => {
      this.exportPolygons();
    }, 0);
  }

  /**
   * export polygons and save it in the browser for further import.
   */
  exportPolygons(): void {
    const format = new GeoJSON();
    const features = this.vectorSource.getFeatures();
    this.anfrage.mapPolygons = format.writeFeatures(features);
    this.requestService.setAnfrage(this.anfrage);
  }

  /**
   * Add a label text with the area size on a given polygon/feature.
   * @param feature
   */
  setTextOnPolygon(feature: Feature): number {
    const polygon = feature.getGeometry() as Polygon;
    const area = getArea(polygon);

    const style = new DrawStyle();
    const text = style.getText();
    text.setText(Math.round(area) + 'm²');
    feature.setStyle(style);

    return area;
  }

  /**
   * import polygons from the browser and show it on the map.
   *
   */
  importPolygons(): void {
    const format = new GeoJSON();
    const geojson = this.anfrage.mapPolygons;
    const features = format.readFeatures(geojson, {
      dataProjection: PhotovoltaikcheckConstants.MAP_PROJECTION,
      featureProjection: PhotovoltaikcheckConstants.MAP_PROJECTION
    });

    // add label
    this.drawArea = 0;
    features.forEach(feature => {
      const area = this.setTextOnPolygon(feature);

      this.drawArea += area;
    });

    // preset inputs
    this.form.get(PhotovoltaikcheckConstants.FIELD_DRAWAREA).setValue(Math.round(this.drawArea));
    this.form.get(PhotovoltaikcheckConstants.MODE_FLAECHE).setValue(Math.round(this.drawArea));

    // add all polygons on the map
    this.vectorSource.clear();
    this.vectorSource.addFeatures(features);

    // show the cancel button
    this.showResetButton();
  }

  /**
   * Reset all polygons that are on the map and reset the area value.
   */
  resetPolygons() {
    // reset the sum and the form value
    this.drawArea = 0;
    this.form.get(PhotovoltaikcheckConstants.MODE_FLAECHE).setValue(null);
    this.form.get(PhotovoltaikcheckConstants.FIELD_DRAWAREA).setValue(0);

    // reset saved polygons in anfrage
    this.anfrage.mapPolygons = null;
    this.requestService.setAnfrage(this.anfrage);

    // stop drawing, if in the middle of something.
    this.drawInteraction.abortDrawing();

    // remove all polygons
    this.vectorSource.clear();

    // hide reset button
    this.map.getControls().forEach(control => {
      if(control instanceof ResetControl) {
        control.hide();
      }
    });
  }

  /**
   * Set the field/mode to calculate the available area
   * @param field
   */
  setField(field: string) {
    this.anfrage.userInput.areaCalculator = field;
    // set field and default helptext
    this.field = field;
    this.helpTextkey = this.helpTextkeyDefault;

    if(this.field !== PhotovoltaikcheckConstants.MODE_FLAECHE) {
      // show one of the calculators
      this.form.get(PhotovoltaikcheckConstants.MODE_FLAECHE).disable();
      this.helpTextkey += '.' + field;
    }
    else {
      // show the manual input
      this.form.get(PhotovoltaikcheckConstants.MODE_FLAECHE).enable();
      this.helpTextkey += this.helptextPostfix;
    }

    // show the map
    if(this.field === PhotovoltaikcheckConstants.FIELD_FLAECHE_KARTE) {
      this.initMap();
      // add formfield to the form to make the form invalid, if noting is selected.
      this.form.get(PhotovoltaikcheckConstants.FIELD_DRAWAREA).enable();
      this.form.get(PhotovoltaikcheckConstants.FIELD_ADDRESS).enable();

      this.form.get(PhotovoltaikcheckConstants.FIELD_DRAWAREA).setValue(this.form.get(PhotovoltaikcheckConstants.MODE_FLAECHE).value);

      // show hint if we have no address
      if(this.form.get(PhotovoltaikcheckConstants.FIELD_ADDRESS).value.length === 0) {
        this.mapHintText = this.MAP_HINT_ADDRESS;
      }
    }
    else {
      // other modes than the map
      this.form.get(PhotovoltaikcheckConstants.FIELD_DRAWAREA).disable();
      this.form.get(PhotovoltaikcheckConstants.FIELD_ADDRESS).disable();
      // reset draw area
      this.drawArea = 0;
    }

    // init some more elements, based on the selected field/mode
    if(this.field === PhotovoltaikcheckConstants.FIELD_FLAECHE_WOHNFLAECHE) {
      // preset livin area and floors
      if(this.anfrage.livingArea) {
        this.form.get(PhotovoltaikcheckConstants.MODE_WOHNFLAECHE).setValue(
          this.anfrage.livingArea
        );
      }
      if(this.anfrage.floors) {
        this.form.get(PhotovoltaikcheckConstants.MODE_STOCKWERKE).setValue(
          this.anfrage.floors
        );
      }


      this.formFields[PhotovoltaikcheckConstants.MODE_WOHNFLAECHE].setActive();
      this.formFields[PhotovoltaikcheckConstants.MODE_STOCKWERKE].setActive();
      this.form.get(PhotovoltaikcheckConstants.MODE_WOHNFLAECHE).enable();
      this.form.get(PhotovoltaikcheckConstants.MODE_STOCKWERKE).enable();
    }
    else {
      this.formFields[PhotovoltaikcheckConstants.MODE_WOHNFLAECHE].setInactive();
      this.formFields[PhotovoltaikcheckConstants.MODE_STOCKWERKE].setInactive();
      this.form.get(PhotovoltaikcheckConstants.MODE_WOHNFLAECHE).disable();
      this.form.get(PhotovoltaikcheckConstants.MODE_STOCKWERKE).disable();
    }
  }

  /**
   * (re)calculate the area, based on the calculation input
   */
  calculateAreaFromCalculator(): void {
    if(this.field !== PhotovoltaikcheckConstants.FIELD_FLAECHE_WOHNFLAECHE) {
      // do not (re)calculate. We have another mode active
      return;
    }
    if(this.form.get(PhotovoltaikcheckConstants.MODE_WOHNFLAECHE).value > 0 &&
      this.form.get(PhotovoltaikcheckConstants.MODE_STOCKWERKE).value > 0) {

      // get values from fields
      this.anfrage.livingArea = this.form.get(PhotovoltaikcheckConstants.MODE_WOHNFLAECHE).value;
      this.anfrage.floors = this.form.get(PhotovoltaikcheckConstants.MODE_STOCKWERKE).value;
      this.requestService.setAnfrage(this.anfrage);

      // calculate available area
      this.availableArea = this.anfrage.livingArea * PhotovoltaikcheckConstants.FLOOR_CALCULATOR_AREA_FACTOR / this.anfrage.floors;
      if(this.anfrage.userInput.aufstellort === PhotovoltaikcheckConstants.AUFSTELLORT_SPITZDACH) {
        this.availableArea = this.availableArea * PhotovoltaikcheckConstants.FLOOR_CALCULATOR_SPITZDACH_FACTOR;
      }
      if(this.anfrage.userInput.aufstellort === PhotovoltaikcheckConstants.AUFSTELLORT_PULTDACH) {
        this.availableArea = this.availableArea * PhotovoltaikcheckConstants.FLOOR_CALCULATOR_PULTDACH_FACTOR;
      }

      this.form.get(PhotovoltaikcheckConstants.MODE_FLAECHE).setValue(
        Math.round(this.availableArea)
      );
    }
    else {
      // this.form.get(PhotovoltaikcheckConstants.MODE_FLAECHE).setValue(null);
    }
  }

  /**
   * @inheritdoc
   */
  onSubmit() {
    // reset form error
    this.formError = null;

    // reactivate the area field so the getData() method get's the data
    this.form.get(PhotovoltaikcheckConstants.MODE_FLAECHE).enable();

    // check if the form is valid
    if(this.form.invalid) {
      // disable inputfield, if one calculator s visible.
      if(this.field !== PhotovoltaikcheckConstants.MODE_FLAECHE) {
        this.form.get(PhotovoltaikcheckConstants.MODE_FLAECHE).disable();
      }

      // check if we have empty fields and set formerror
      if(this.form.get(PhotovoltaikcheckConstants.MODE_FLAECHE)?.hasError('required') ||
        this.form.get(PhotovoltaikcheckConstants.MODE_WOHNFLAECHE)?.hasError('required') ||
        this.form.get(PhotovoltaikcheckConstants.MODE_STOCKWERKE)?.hasError('required')) {

        // set formerror if field is empty
        this.formError = 'emptyfield';
      }
      else {
        // set own formerror if area is invalid
        this.formError = 'invalid_flaeche';
      }

      // set formerror if address is empty
      if (this.form.get(PhotovoltaikcheckConstants.FIELD_ADDRESS)?.hasError('required')) {
        this.formError = 'empty_address';
      }
      // set formerror if drawarea is empty
      else if(this.field === PhotovoltaikcheckConstants.FIELD_FLAECHE_KARTE && this.drawArea === 0) {
        this.formError = 'empty_flaeche_karte';
      }

      return;
    }

    super.onSubmit();
  }
}
